import axios from '@/utils/request'
import { AxiosPromise } from 'axios'
import { BaseResponse, ResponseStatus } from '.'

export { BaseResponse, ResponseStatus }

export interface AccountInfo {
  userId: string
  phoneNumber: string
  phoneNumberConfirmed: boolean
  discordId: string
}

export interface AddPhoneNumberRequest {
  phoneNumber: string
}

export interface ConfirmPhoneNumberRequest {
  phoneNumber: string
  verificationCode: string
}

export interface SetDiscordIdRequest {
  discordId: string | null
}

export class IdentityAPI {
  public static BASE_PATH = process.env.VUE_APP_IDENTITY_API_ENDPOINT
  public static API_PREFIX = '/api/v1'

  public static getAccount(): AxiosPromise {
    return axios.get(`${this.BASE_PATH}${this.API_PREFIX}/account`)
  }

  public static addAccountPhoneNumber(
    request: AddPhoneNumberRequest
  ): AxiosPromise<BaseResponse> {
    return axios.post(
      `${this.BASE_PATH}${this.API_PREFIX}/account/phone_number`,
      request
    )
  }

  public static setAccountDiscordId(
    request: SetDiscordIdRequest
  ): AxiosPromise<BaseResponse> {
    return axios.post(
      `${this.BASE_PATH}${this.API_PREFIX}/account/discord_id`,
      request
    )
  }

  public static confirmAccountPhoneNumberRequest(
    request: ConfirmPhoneNumberRequest
  ): AxiosPromise<BaseResponse> {
    return axios.post(
      `${this.BASE_PATH}${this.API_PREFIX}/account/phone_number/confirm`,
      request
    )
  }
}
